import React, { useEffect, useRef, useState } from 'react';
import './ElectronOneTime.css';
import Header from '../Header/Header';
import { useNavigate } from 'react-router-dom';
import MetaMask from '../Util/MetaMask';
import DataModel from '../Util/DataModel';
import Loading from '../Loading/Loading';
import { useRecoilState } from 'recoil';
import { topMessageAtom } from '../../State';
import { useTranslation } from 'react-i18next';
import NoMetaMask from '../ElectronMetaMask/NoMetaMask';

export default function ElectronOneTime({ createCall, startHairCheck }) {
  const [addressState, setAddressState] = useState(false);
  const [codeState, setCodeState] = useState('');
  const [loadingState, setLoadingState] = useState(false);
  const [topMessageState, setTopMessageState] = useRecoilState(topMessageAtom);
  const [noMetaMaskState, setNoMetaMaskState] = useState(false);
  const { t } = useTranslation();

  const connect = async () => {
    //ローディング開始
    setLoadingState(true);

    //ログイン＋コード取得
    const code = await DataModel.getMetaMaskAddress();

    if (code == 'noinstall') {
      setNoMetaMaskState(true);
    } else if (code != null) {
      setCodeState(code);
      setAddressState(true);
    } else {
      console.log('エラー');
      setTopMessageState({
        type: 'joined',
        message: t('electron.There is an error'),
      });
    }
    //ローディング終了
    setLoadingState(false);
  };

  /*
  const connect = async () => {
    //ローディング開始
    setLoadingState(true);

    //ログイン＋コード取得
    const code = await DataModel.login(true);

    if (code == 'noinstall') {
      setNoMetaMaskState(true);
    } else if (code != null) {
      setCodeState(code);
      setAddressState(true);
    } else {
      console.log('エラー');
      setTopMessageState({
        type: 'joined',
        message: 'There is an error',
      });
    }
    //ローディング終了
    setLoadingState(false);
  };
  */

  //クリップボードにコピー
  const copyURL = () => {
    navigator.clipboard.writeText(codeState).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
  };

  return (
    <>
      {/*メタマスクをインストールして*/}
      {noMetaMaskState && <NoMetaMask setNoMetaMaskState={setNoMetaMaskState} />}
      <Loading loadingState={loadingState} />
      <Header isHome={true} />
      <div className="loginMetamaskWrap">
        <div id="loginMetamaskArea">
          {addressState ? (
            <>
              <p id="electronOneTimeH1">
                {' '}
                {t('electron.Go back to FACELESS app & paste the code below')}
              </p>
              <div id="electronOnetimeCode">
                <div id="electronCodeShow">{codeState}</div>
                <button onClick={copyURL}>{t('electron.Copy Code')} </button>
                {/* <div className="electronCodeWarning">*This code will expire after 10 min</div> */}
              </div>
            </>
          ) : (
            <>
              <p>{t('electron.Connect To Metamask')}</p>
              <div id="electronOnetime">
                <button onClick={connect} id="loginButton">
                  <img src="./images/header/metaMask.svg" />
                  <span> {t('electron.Connect To Metamask')}</span>
                </button>

                <div className="electronCodeWarning">
                  *{t('electron.You need to install Metamask extention')}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
